export default {
  freeTimesLimitTitle: 'De gratis proefversie is vandaag op.',
  fileSizeLimitTitle:
    'De bestandsgrootte mag niet groter zijn dan 20 MB in gratis versie.',
  total: 'Totaal',
  enterCode: 'Voer code in',
  signUpToPurchaseBtn: 'Meld u aan om te kopen',
  goPurchseBtn: 'Ga naar Kopen',
  saveTips: 'Bespaar tot {{num}}%',
  discount: 'Korting',
  montly: 'Maandelijks',
  yearly: 'Jaarlijks',
  weekly: 'Wekelijks',
  week: 'Week',
  priceWeek: '$9,99',
  priceMonth: '$7,49',
  priceYearly: '$3,75',
  billMonth: '$29,99 Maandelijks gefactureerd',
  billYear: '$179,99 Jaarlijks gefactureerd',
  AlreadySubscribe: 'Al geabonneerd?',
  vipTips1: 'Geen bestandsgrootte limieten',
  vipTips2: 'Geen limiet aan het aantal verwerkte bestanden',
  vipTips3: 'Wijzig beeldachtergronden zonder limieten',
  vipTips4: 'Toegang tot alle gratis tools en premium -functies',
  purchaseTips: 'Automatisch verlengen en op elk moment opzeggen.',
  tips: 'Tips:',
  promoCodeInvalidTips: 'Uw promotiecode is ongeldig',
};
